function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
  fill: "#F0F0F0"
}), React.createElement("path", {
  d: "M4.52197 10.7826L5.21763 15.5025C6.08425 15.8241 7.02166 16 8.00022 16C11.4399 16 14.3723 13.829 15.5026 10.7826H4.52197Z",
  fill: "black"
}), React.createElement("path", {
  d: "M4.52197 5.21741L5.21763 0.497531C6.08425 0.175937 7.02166 0 8.00022 0C11.4399 0 14.3723 2.171 15.5026 5.21741H4.52197Z",
  fill: "#6DA544"
}), React.createElement("path", {
  d: "M0 7.99996C0 11.4397 2.17103 14.372 5.21741 15.5024V0.497559C2.17103 1.6279 0 4.56025 0 7.99996Z",
  fill: "#A2001D"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgUae = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgUae, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uae.bded6c7b.svg";
export { ForwardRef as ReactComponent };